var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrameUpDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#clip0_64_17364)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_64_17364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 35
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 0H0V35H35V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_64_17364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31 0.5H4C2.067 0.5 0.5 2.067 0.5 4V31C0.5 32.933 2.067 34.5 4 34.5H31C32.933 34.5 34.5 32.933 34.5 31V4C34.5 2.067 32.933 0.5 31 0.5Z",
    fill: "#006AB3",
    stroke: "#006AB3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M25.5714 16.5714H18.4286V9.42857C18.4286 8.64 17.7886 8 17 8C16.2114 8 15.5714 8.64 15.5714 9.42857V16.5714H8.42857C7.64 16.5714 7 17.2114 7 18C7 18.7886 7.64 19.4286 8.42857 19.4286H15.5714V26.5714C15.5714 27.36 16.2114 28 17 28C17.7886 28 18.4286 27.36 18.4286 26.5714V19.4286H25.5714C26.36 19.4286 27 18.7886 27 18C27 17.2114 26.36 16.5714 25.5714 16.5714Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_64_17364"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrameUpDisabled);
export default __webpack_public_path__ + "static/media/FrameUpDisabled.2bf3989bc584db327b66e174b113b2e7.svg";
export { ForwardRef as ReactComponent };